import "./scss-core/style.scss";

//DEV/SRC - JS GLOBAL
import { bp } from "./js-global/variables-constants/breakpoints";
//import "./js-global/variables-constants/dom-elements";

import "./js-global/functions/functions";

import "./js-global/visitor";
import "./js-global/site";

//DEV/SRC - TEMPLATE PARTS
import "./template-parts/template-parts";

//THEME COMPONENTS
import "../wp-content/themes/my-vip/components/components";
import "../wp-content/themes/my-vip/inc/quiz/quiz";

//SLIDERS INIT
import "./js-global/sliders-init/sliders-init";

//SPECIAL EFFECTS
import "./special-effects";


//DYNAMIC BLOCK NEED IDEA? ADJUSTMENTS
function setNeedIdeasSliderLeft() {
    var cont = document.querySelector('.need-ideas .container');
    var rect = cont.getBoundingClientRect();
    $('.need-ideas-slider-wrapper').css('padding-left', (rect.left+15)+'px');
  }
  $(function () {
    setNeedIdeasSliderLeft();   

    $(window).on('resize', function () { 
        setNeedIdeasSliderLeft();   
    });
  });
//END DYNAMIC BLOCK NEED IDEA? ADJUSTMENTS

//JOBS SS FILTER HANDLING
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/scrollTrigger.js";
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

function showJobsSSFilter() {
	var showJobsSSFilter = gsap.timeline({ repeat: 0, repeatDelay: 1 });

	showJobsSSFilter.set(".mobile-filter", { display: "block" });
	showJobsSSFilter.to(".mobile-filter .site-content__secondary-inner", {
		duration: 0.5,
		opacity: 1,
		y: "-50%",
		ease: "power2.out",
	});
	//showJobsSSFilter.to("example", {duration: 1, x: 200, scale: 0.2});
	//showJobsSSFilter.to("example", {duration: 1, x: 200, scale: 2, y: 20});
}

function closeJobsSSFilter() {
  var closeJobsSSFilter = gsap.timeline({repeat: 0, repeatDelay: 1});
  
  closeJobsSSFilter.to(".mobile-filter .site-content__secondary-inner", {
		duration: 0.5,
		opacity: 0,
		y: "0%",
		ease: "power2.out",
	});
  closeJobsSSFilter.set(".mobile-filter", { display: 'none'});
  //closeJobsSSFilter.to("example", {duration: 1, x: 200, scale: 0.2});
  //closeJobsSSFilter.to("example", {duration: 1, x: 200, scale: 2, y: 20});
}

$(".jobs-ss-filter-trigger").on('click', function (e) {
	e.preventDefault();
  showJobsSSFilter();
});
$(".close-ss-filter").on("click", function (e) {
	e.preventDefault();
	closeJobsSSFilter();
});

$("#job-filter-search").on("keyup", function (e) {
	if (e.key === "Enter" || e.keyCode === 13) {
		// Do something
		$("#btn-header-search").trigger("click");
	}
});
//END JOBS SS FILTER HANDLING

//QUIZ JOB SWITCH VIEWS
$("body").on(
	"click",
	".quiz .view-options__grid",
	function (e) {
		e.preventDefault();

		$(".quiz #jobs > .row").removeClass("job-list--display-as-rows");
		$(".quiz #jobs > .row").addClass("job-list--display-as-grid");
	}
);
$("body").on(
	"click",
	".quiz .view-options__list",
	function (e) {
		e.preventDefault();

		$(".quiz #jobs > .row").addClass("job-list--display-as-rows");
		$(".quiz #jobs > .row").removeClass("job-list--display-as-grid");
	}
);

function replaceTeamName() {
	// Replace "Team Name" inside <strong> tags
	$("strong").each(function () {
		if ($(this).text().trim() === "Team Name:") {
			$(this).text("School Name");
		}
	});

	// Replace "Team Name" inside <label> tags
	$("label:contains('Team Name')").each(function () {
		var text = $(this).html();
		var newText = text.replace("Team Name", "School Name");
		$(this).html(newText);
	});

	// Replace "Team Name:" inside <dt> tags with a class containing "TeamName"
	$("dt[class*='TeamName']:contains('Team Name:')").each(function () {
		$(this).text("School Name:");
	});

	// Replace 'Field "Team Name" is required.' inside the specific <div>
	$(".woocommerce-error li").each(function () {
		var text = $(this).text();
		if (text.includes("Field 'Team Name' is required.")) {
			var newText = text.replace("Field 'Team Name'", "Field 'School Name'");
			$(this).text(newText);
		}
	});
}

// Run on document ready
$(document).ready(replaceTeamName);

// Create an observer instance to watch for changes in the entire document
var observer = new MutationObserver(function () {
	replaceTeamName();
});

// Configuration for the observer
var config = {
	attributes: true,
	childList: true,
	characterData: true,
	subtree: true, // Observes the entire subtree of the document
};

// Target node (observing the entire body)
var target = document.body;

// Start observing the target node
observer.observe(target, config);
